import React, { PropTypes } from 'react';
import classNames from 'classnames';

import MapIcon from '../MapIcon';
import Pin from '../Pin';

import '../styles.scss';


const ChargerMarker = ({ charger, className, children, ...props }) => (
  <MapIcon
    className={classNames(
      'charger', {
        supercharger: charger.is_supercharger,
        'destination-charger': !charger.is_supercharger,
      },
      className,
    )}
    styleName='charger'
    {...props}
  >

    <Pin />

    { children }

  </MapIcon>
);

ChargerMarker.propTypes = {
  charger: PropTypes.shape({ is_supercharger: PropTypes.bool }).isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  selected: PropTypes.bool,
};

ChargerMarker.defaultProps = {
  children: null,
  className: null,
  selected: false,
};

export default ChargerMarker;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/MapMarker/Charger/index.jsx